import { render } from "./EsDefaultLayout.vue?vue&type=template&id=c0ea1b96"
import script from "./EsDefaultLayout.vue?vue&type=script&lang=js"
export * from "./EsDefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__